import React from 'react'
import { IModalSizeOptions, ModalSize } from 'marketing-site/src/components/common/Modal'
import { ModalWithPersistedState } from 'marketing-site/src/library/elements/ModalWithPersistedState'
import { IProps } from './index'
import { useModalContext } from 'marketing-site/src/components/context/ModalContext'

export const Modal: React.FC<IProps> = ({
  modalSize,
  backgroundColor,
  blurOverlay,
  preventClosing,
  renderModalContent,
  modalId,
}) => {
  const { modalOpen, closeModal } = useModalContext()

  const isModalOpen = modalOpen === modalId

  const modalSizeKey: IModalSizeOptions = modalSize

  return (
    <ModalWithPersistedState
      isOpen={isModalOpen}
      onRequestClose={preventClosing ? () => {} : closeModal}
      showCloseIcon={!preventClosing}
      size={ModalSize[modalSizeKey]}
      hasBlurredOverlay={blurOverlay}
      backgroundColor={backgroundColor}
    >
      {renderModalContent()}
    </ModalWithPersistedState>
  )
}
